<div class="menu">
  <span class="menu-heading">Add/Edit Avatar</span>
  <span class="close" (click)="closeEditAvatarPopup()">X</span>
</div>

<div class="row console p-0 m-0">
  <div class="col-8 left-col border pt-1">
    <span class="console-heading">Upload File</span>

    <div class="upload">
      <form>
        <image-uploader
          (files)="filesDropped($event)"
          [activeColor]="'orangered'"
          [baseColor]="'Navy'"
          class="img-uploader"
        ></image-uploader>
      </form>
    </div>
  </div>

  <div class="col-4 border pt-5">
    <span class="item-right">REQUIREMENTS</span><BR />
    <span class="item-right sub">Allowed File Types</span>
    <ul class="list-styled item-list mt-2 ps-4">
      <li>JPEG image (jpg/jpeg)</li>
      <li>PNG Image (png)</li>
      <li>GIF Image (gif)</li>
      <li>Bitmap Image (bmp)</li>
    </ul>
    <span class="item-right sub">Maximum File Size</span>
    <ul class="list-styled item-list mt-2 ps-4">
      <li>10 MB</li>
    </ul>
  </div>
</div>

<div class="menu-bottom text-center">
  <button class="main-btn large" (click)="UpdateAvatar()">Save</button>
  <button class="outline-btn large ms-2" (click)="goBack()">Cancel</button>
</div>
